<template>
  <div class="expandable-transaction-check-list">
    <div class="transaction-list-description">
      <div class="title-with-expand-collapse" v-on:click="toggleExpand">
        <div class="title" :class="[colorVariant]">{{ title }}</div>
        <div v-if="isExpandable" class="image-container">
          <img v-if="isExpanded" :src="require('@/assets/onboarding/icons/arrow-up.svg')">
          <img v-else :src="require('@/assets/onboarding/icons/arrow-down.svg')">
        </div>
      </div>
      <slot name="subtitle" v-if="(isExpanded || !isExpandable)"/>
    </div>
    <separator v-if="transactionList" />
    <transaction-check-list v-if="transactionList && (isExpanded || !isExpandable)" :transaction-list="transactionList" :toggleCheck="toggleCheck"/>
  </div>
</template>

<script>
import BaseUI from 'base-ui';
import TransactionCheckList from './TransactionCheckList.vue';

export default {
  name: 'ExpandableTransactionCheckList',
  components: {
    TransactionCheckList,
    Separator: BaseUI.Separator,
  },
  props: {
    transactionList: {
      type: Array,
      required: false,
    },
    toggleCheck: {
      type: Function,
      required: true,
    },
    isExpandable: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
      required: true,
    },
    colorVariant: {
      type: String,
      validator: val => ['green', 'red'].includes(val),
    },
    expandOnCreate: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isExpanded: false,
    };
  },
  created() {
    if (this.expandOnCreate) {
      this.isExpanded = true;
    }
  },
  methods: {
    toggleExpand() {
      this.isExpanded = !this.isExpanded;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../node_modules/base-ui/src/scss/riseup-colors';
@import '../../scss/mixins';

.expandable-transaction-check-list {
  .transaction-list-description {
    @include responsive-padding;

    .title-with-expand-collapse {
      margin: 30px 0 25px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .title {
        font-size: 18px;
        font-weight: bold;
        &.green {
          color: $riseup_green;
        }
        &.red {
          color: $riseup_red;
        }
      }

      .image-container {
        height: 100%;
      }
    }
  }
}
</style>
